import { h, render, Fragment } from 'preact';

export default (element, data) => {
  const CollectionFilter = (props) => {
    // Lookup variant based on selected options
    

    return (
      <>
        <div class="collection-filter">

        </div>
      </>
    )
  }

  

  const init = async () => {
    // render(<CollectionFilter data={data} />, element)
  }

  init();
}
